<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M19.02 20.99H4.98a2.94 2.94 0 0 1-2.58-1.5 2.95 2.95 0 0 1 0-2.98L9.43 4.48A2.95 2.95 0 0 1 12 3c1.07 0 2.03.55 2.58 1.48l7.02 12.03c.54.94.55 2.05 0 2.98-.53.94-1.5 1.5-2.57 1.5ZM10.87 5.32 3.85 17.35c-.24.4-.24.9 0 1.3.24.42.66.67 1.14.67h14.04a1.31 1.31 0 0 0 1.14-1.97L13.12 5.32a1.31 1.31 0 0 0-2.26 0Z"
    />
    <path
      d="m10.94 13.37-.3-3.27a16.5 16.5 0 0 1-.09-1.37c0-.38.14-.68.42-.89.27-.2.64-.31 1.1-.31.55 0 .92.13 1.1.4.19.28.28.66.28 1.17 0 .3-.03.61-.07.92l-.42 3.37c-.04.4-.14.7-.29.92-.15.2-.4.31-.73.31-.33 0-.58-.1-.71-.3-.14-.21-.24-.53-.3-.95h.01Zm1.07 4.91c-.4 0-.73-.12-1.03-.37-.29-.26-.43-.61-.43-1.07 0-.4.14-.73.42-1a1.4 1.4 0 0 1 1.02-.42c.41 0 .76.14 1.04.41.28.28.43.62.43 1.01 0 .46-.15.8-.44 1.07-.3.25-.62.38-1 .38Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
